import styled from 'styled-components'
import { colorTheme } from '../../../../../../style/theme/colorTheme'
import { theme } from '../../../../../../style/theme'

export const MarkReadyOrderButtonWrapper = styled.button`
	font-size: 1rem;
	display: flex;
	align-items: center;
	gap: 0.38em;
	width: fit-content;
	min-height: 2.25em;
	margin-top: 0.31em;
	padding: 0.19em 0.94em 0.19em 0.19em;
	border: none;
	border-radius: 0.75em;
	background-color: ${colorTheme.orders.table.markReadyButton.background};
	cursor: pointer;
	transition: all 0.3s ease;

	&:hover {
		box-shadow: 0 0 0 0.13em ${colorTheme.button.type.borderHover}, 0 0.38em 0.38em 0 ${colorTheme.orders.table.markReadyButton.hoverShadow};
	}
`
MarkReadyOrderButtonWrapper.displayName = 'MarkReadyOrderButtonWrapper'

export const MarkReadyOrderIconWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 1.8em;
	height: 1.8em;
	border-radius: 0.6em;
	background-color: ${colorTheme.orders.table.markReadyButton.iconBackground};

	> svg {
		width: 1.5em;
		height: 1.5em;
		flex-shrink: 0;
	}
`
MarkReadyOrderIconWrapper.displayName = 'MarkReadyOrderIconWrapper'

export const MarkReadyOrderText = styled.div`
	color: ${colorTheme.orders.table.markReadyButton.text};
	font-family: ${theme.fontRobotoMedium};
	font-size: 1em;
`
MarkReadyOrderText.displayName = 'MarkReadyOrderText'
